import React from "react";
import { Avatar } from "@material-ui/core";
import "./sideBarRow.css";

const SidebarRow = ({ src, Icon, title }) => {
  return (
    <div className="siderow-wrapper">
      {src && <Avatar src={src} />}
      {Icon && <Icon />}
      <p>{title}</p>
    </div>
  );
};

export default SidebarRow;
